document.addEventListener('click', e => {
  if (!(e.target.matches('.modal-button') || e.target.closest('.modal-button'))) return;
  e.preventDefault();

  const button = e.target.matches('.modal-button') ? e.target : e.target.closest('.modal-button');
  const selector = button.getAttribute('href').replace('/', '').replace('#', '');

  console.log("selector", selector);

  const modal = document.querySelector(`.contact-modal[name="${selector}"]`);
  
  if (button.hasAttribute('data-course-name') && modal.querySelector('.course-form__name')) {
    modal.querySelector('.course-form__name').value = button.getAttribute('data-course-name');
  }
  if (button.hasAttribute('data-course-location') && modal.querySelector('.course-form__location')) {
    modal.querySelector('.course-form__location').value = button.getAttribute('data-course-location');
  }
  if (button.hasAttribute('data-course-date') && modal.querySelector('.course-form__date')) {
    modal.querySelector('.course-form__date').value = button.getAttribute('data-course-date');
  }

  // Hides nav menu
  if ( document.querySelector('.navbar') !== null ) {
    document.querySelector('.navbar').style.display = 'none';
  }

  modal.classList.add('contact-modal--active');

  const headerHeight = modal.querySelector('.contact-modal__top').offsetHeight;

  modal.querySelector('.contact-modal__form').style.paddingTop = headerHeight + 'px';

  // Unblocks Turnstile for Modal
  window.SS88TurnstileCallback();

});

document.addEventListener('resize', () => {

  [...document.querySelectorAll('.contact-modal--active')].forEach(modal => {
    const headerHeight = modal.querySelector('.contact-modal__top').offsetHeight;
  
    modal.querySelector('.contact-modal__form').style.paddingTop = headerHeight + 'px';
  })

});;

document.addEventListener(
  'click',
  (e) => {
    if ( e.target.matches('.contact-modal__close') ) {
      e.target.closest('.contact-modal').classList.remove('contact-modal--active');

      // Shows nav menu
      if ( document.querySelector('.navbar') !== null ) {
        document.querySelector('.navbar').style.display = 'block';
      }
    }
  }
);
